<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/shopvolumetj/select"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      :show="false"
      :totalShow="true"
      totalShowType="warning"
      totalName="导出"
      totaltext="/shopvolumetj/export"
      @totalLookDialog="totalLookDialog"
    >
      <el-form-item label="代理商ID">
        <el-input v-model="formModel.agentId" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="商户号">
        <el-input
          v-model="formModel.machinesId"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
         <el-form-item label="身份证号">
        <el-input
          v-model="formModel.idCardNo"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="月份">
        <el-date-picker
          v-model="formModel.date"
          type="month"
          value-format="yyyy-MM"
          format="yyyy-MM"
          placeholder="选择月"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="agentId"
        label="代理商ID"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="machinesId"
        label="商户号"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
        <el-table-column
        prop="feeActivityType"
        label="商户费率"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
        <el-table-column
        prop="idCardNo"
        label="商户身份证号"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
        <el-table-column
        prop="weComFlag"
        label="是否开通企业微信"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      >
       <template slot-scope="scope">
          <span v-if="scope.row.weComFlag == 0">否</span>
          <span v-else-if="scope.row.weComFlag == 1">是</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="date"
        label="月份"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="money"
        label="全部交易(元)"
        :formatter="formatterTableNumber"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="examineMoney"
        label="POS交易额(元)"
        :formatter="formatterTableNumber"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
    </common-table>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import StatisticsService from "service/StatisticsService";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "shopvolumetj",
  components: {
    CommonTopForm,
    CommonTable,
  },
  data() {
    return {
      formModel: {
        agentId: "",
        machinesId: "",
        date: "",
        idCardNo: ''
      },
      tableData: [],
      submitService: StatisticsService.shopvolumetjListTwo,
      params: {},
      page: {},
      isPage: false,
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
  },
  computed: {
    submitData() {
      const params = {
        agentId: this.formModel.agentId,
        idCardNo: this.formModel.idCardNo,
        machinesId: this.formModel.machinesId,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
        date: this.formModel.date,
      };
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
  },
  methods: {
    load() {
      this.formModel = {
        date: "",
      };
      this.page = this.$refs.commonTable.page;
      this.getList();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    totalLookDialog() {
      this.limitExport(this.page.total)
        ? StatisticsService.exportExcel(
            this.submitData,
            "listExport2",
            "8883",
            "/statistics/machines-transaction/"
          )
        : "";
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/Statistics/ShopVolumeTjTwo.vue